import Issues from 'components/issues';

const IssuesPage = () => {
  return <Issues />;
};

export default IssuesPage;
